export default (theme) => ({
    accordionSummary: { padding: `${theme.spacing(1)} ${theme.spacing(4)}` },
    accordionDetails: { padding: `0 ${theme.spacing(4)}` },
    typoBold: { fontWeight: "bold" },
    divider: { paddingTop: theme.spacing(2) },
});
